export default __webpack_public_path__ + "static/media/LoadingGif.e9aca3ba.gif";